export default "__VITE_ASSET__BbUXauMq__"